"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _solarReact2 = require("@probeton/solar-react");

var _excluded = ["children", "icon", "size", "text", "textLabel", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    listItemSmall: {
      alignItems: 'flex-start',
      padding: 8
    },
    listItemTextSmall: {
      padding: 0,
      paddingLeft: 8,
      '& > *': {
        fontSize: '0.8em',
        paddingTop: 2
      }
    },
    children: {
      flex: '0 0 auto',
      padding: '8px 16px'
    },
    limited: {
      flex: '1 1 auto'
    }
  };
});

var ProfileItem = function ProfileItem(_ref) {
  var _classNames;

  var children = _ref.children,
      icon = _ref.icon,
      size = _ref.size,
      text = _ref.text,
      textLabel = _ref.textLabel,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ListItem, _extends({
    classes: {
      root: size === 'small' && classes.listItemSmall
    },
    button: !!onClick,
    onClick: onClick
  }, other), icon ? /*#__PURE__*/_react["default"].createElement(_solarReact2.ListItemIcon, null, icon) : '', (text || textLabel) && /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, _extends({
    primary: text || textLabel
  }, text && textLabel ? {
    secondary: textLabel
  } : {}, {
    classes: {
      root: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classes.listItemTextSmall, size === 'small'), _defineProperty(_classNames, classes.limited, !!children), _classNames))
    }
  })), children && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.children
  }, children));
};

ProfileItem.propTypes = {
  children: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  size: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string,
  textLabel: _propTypes["default"].string.isRequired
};
ProfileItem.defaultProps = {
  size: 'default'
};
var _default = ProfileItem;
exports["default"] = _default;